import React from "react";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";

// Config
import colors from "../../config/colors";
import styles from "../../config/styles";

// Assets
import encourageIcon from "../../assets/icons/encourage-icon.svg";

// Components
import AddMediaPerpetrator from "../AddMediaPerpetrator";
import Text from "../Text";

const useStyles = makeStyles(theme => ({
  root: {
    border: styles.values.border,
    borderColor: colors.wildSand,
    backgroundColor: colors.wildLand,
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
    width: `calc(50% - ${theme.spacing(1)}px)`,
    marginBottom: theme.spacing(2)
  },
  title: {
    fontSize: 15
  },
  icon: {
    width: 58,
    height: 58
  }
}));

const EncourageSuspectMediaCard = () => {
  const classes = useStyles();

  return (
    <Card component="article" variant="outlined" className={classes.root}>
      <img className={classes.icon} src={encourageIcon} alt="" />
      <Text
        className={classes.title}
        type="heading6"
        text="mediaPage.encourageCard.title"
      />
      <Text
        align="center"
        type="contentLabel2"
        text="mediaPage.encourageCard.description"
      />
      <AddMediaPerpetrator
        text="mediaPage.encourageCard.button"
        buttonProps={{
          variant: "outlined",
          color: "default"
        }}
      />
    </Card>
  );
};

export default EncourageSuspectMediaCard;
